import React from "react";
import { useHistory } from "react-router-dom";
import CreateUsers from "../create-user-page/CreateUsers";
import addUserIcon from "../common/static/images/add-user.png";
import { ROUTE } from "../common/utils/route";
import topImage from "../common/static/images/top-image.png";
import rmSmallLogo from "../common/static/images/rm-logo-small.svg";
import ViewReport from "../view-report/ViewReport";
import viewReportIcon from "../common/static/images/view-report.png";
import DownloadTraineeReport from "../trainee-report/TraineeReport";
import downloadTraineeReportIcon from "../common/static/images/trainee-report.png";
import { getUser } from "../common-package/user";
import FrontPage1 from "../common-package/FrontPage1";
enum DialogWindows {
  DEFAULT,
  UPLOAD_USER,
  UPLOAD_BULK_USER,
  UPLOAD_DOCUMENTS,
  ViewReport,
  DownloadTraineeReport,
}

function FrontPage() {
  const [openFunctionDialog, setOpenFunctionDialog] =
    React.useState<DialogWindows>(DialogWindows.DEFAULT);

  const user = getUser();

  let history = useHistory();
  const protectivelyNavigate = (functionName: DialogWindows) =>
    user ? setOpenFunctionDialog(functionName) : history.push(ROUTE.LOGIN);

  return (
    <FrontPage1
      centeredCards={true}
      onClickLogin={() => history.push(ROUTE.LOGIN)}
      cardDetailsList={[
        {
          onStart: () => protectivelyNavigate(DialogWindows.UPLOAD_USER),
          label: "Add New User",
          imageUri: addUserIcon,
          tooltip: "Have a new user? \n Add them now.",
          tooltipPosition: "top-start",
        },
        {
          label: "View Reports",
          imageUri: viewReportIcon,
          onStart: () => protectivelyNavigate(DialogWindows.ViewReport),
          tooltip: "View public reports here",
          tooltipPosition: "top-end",
        },
        {
          label: "Trainee Report",
          imageUri: downloadTraineeReportIcon,
          onStart: () =>
            protectivelyNavigate(DialogWindows.DownloadTraineeReport),
          tooltip: "Download trainee report here",
          tooltipPosition: "top-end",
        },
      ]}
      topImageUri={topImage}
      footerLogoUrl={rmSmallLogo}
    >
      <CreateUsers
        authenticated={!!user}
        open={openFunctionDialog === DialogWindows.UPLOAD_USER}
        onClose={() => setOpenFunctionDialog(DialogWindows.DEFAULT)}
      />
      <ViewReport
        open={openFunctionDialog === DialogWindows.ViewReport}
        onClose={() => setOpenFunctionDialog(DialogWindows.DEFAULT)}
      />
      <DownloadTraineeReport
        authenticated={!!user}
        open={openFunctionDialog === DialogWindows.DownloadTraineeReport}
        onClose={() => setOpenFunctionDialog(DialogWindows.DEFAULT)}
      />
    </FrontPage1>
  );
}

export default FrontPage;
